import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {businessPlans} from "utils/constants/BenevPlans";

const initialState: BenevPlan = businessPlans.entrepreneurLite;

const subscriptionPlanSlice = createSlice({
  name: 'subscriptionPlan',
  initialState,
  reducers: {
    updateSubscriptionPlan: (state, action: PayloadAction<BenevPlan>) => action.payload
  }
})

export const {updateSubscriptionPlan} = subscriptionPlanSlice.actions;

export default subscriptionPlanSlice.reducer;
